<template>
  <div>
    <board-member-index
      :formSearch="formSearch"
      :enableExport="false"
      :columns="columns"
      :title="$t('menu.board_member_list')"
      :serviceName="serviceName"
    />
  </div>
</template>

<script>
import BoardMemberIndex from "./BoardMemberIndex";
export default {
  name: "Index",
  data() {
    return {
      serviceName: "board-members",
      formSearch: [
        {
          label: this.$t("board_member.name"),
          name: "name__~",
          value: "",
          type: "input"
        }
      ],
      columns: {
        id: this.$t("board_member.id"),
        avatar: this.$t("board_member.avatar"),
        name: this.$t("board_member.name"),
        description: this.$t("board_member.description"),
        order_number: this.$t("board_member.order_number"),
        created_at: this.$t("board_member.created_at"),
        updated_at: this.$t("board_member.updated_at")
      }
    };
  },
  components: { BoardMemberIndex },
  methods: {},
  mounted() {}
};
</script>
